const STATE = {
  placeholders: [],
  isSettingsWasChanged: false,
  isDesignerSidebarOpened: true,
  searchValue: '',
  data: null,
  fields: null,
  form: null,
  relatedFields: null,
  unrelatedFields: null,
  item: null,
  primaryKey: null,
  isEditMode: false,
  isModalOpened: false,
  addEditSectionModal: {
    isOpen: false,
    isEditMode: false,
    sectionName: null,
    sectionId: null,
  },
  copySections: null,
  isSectionsReorderModalOpened: false,
  customisationsModal: {
    isOpen: false,
    title: null,
    isEditMode: false,
    sectionId: null,
  },
  mouseXY: {
    x: null,
    y: null,
  },
  dndSectionId: null,
  parentRefs: null,
};

export default STATE;